import Modal from "../components/Modal";
import { XIcon } from "@heroicons/react/solid";
import { useState } from "react";
function AddClass({onClose}) {
    const [passcode, setPasscode] = useState("");
    const handleSubmit = (e) => {
        alert("Are you sure you want to add this class?");
    }
    return (
        <Modal>
             <div className="relative bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all w-11/12 max-w-md">
        <div className="px-4 py-4 sm:px-6 flex flex-row-reverse">
          <button
            onClick={onClose}
            className="p-2 rounded-lg bg-white hover:bg-slate-100"
          >
            <XIcon
              className="w-5 text-gray h-5 font-bold "
              aria-hidden="true"
            />
          </button>
        </div>
        <div className="flex flex-row items-center justify-around mb-8">
          <div className="px-12">
            <h1 className="text-2xl text-center font-bold mb-2">Add a Class</h1>
            <p className="text-sm text-slate-500 p-4">Enter the passcode provided by your instructor</p>
            <input
                type="text"
                className="w-full border-2 border-slate-100 rounded-lg p-2 focus:border-slate-500"
                placeholder="Passcode"
                value={passcode}
                onChange={(e) => setPasscode(e.target.value)}
                />
          </div>
        </div>
        <div className="flex flex-row justify-around mb-12">
            <button
                onClick={handleSubmit}
                className="btn-primary w-1/2"
            >
                    <p >Submit</p>
            </button>
            </div>





      </div>
        </Modal>
    )
}

export default AddClass;